<app-table [data]="toolLifecycleHistory"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [title]="'admin.tool-history.lifecycle-history-table.title' | translate"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column [header]="'admin.tool-history.lifecycle-history-table.columns.toolUid' | translate"
                      [filterPlaceholder]="'admin.tool-history.lifecycle-history-table.filter.placeholder.toolUid' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="toolUid">
    </app-table-column>
    <app-table-column [header]="'admin.tool-history.lifecycle-history-table.columns.toolName' | translate"
                      [filterPlaceholder]="'admin.tool-history.lifecycle-history-table.filter.placeholder.toolName' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="toolName">
    </app-table-column>
    <app-table-column [header]="'admin.tool-history.lifecycle-history-table.columns.line' | translate"
                      [filterPlaceholder]="'admin.tool-history.lifecycle-history-table.filter.placeholder.line' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="line">
        <ng-template #body
                     let-toolLifecycleHistory="rowData">
            <span>{{ toolLifecycleHistory.line.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.tool-history.lifecycle-history-table.columns.partNumber' | translate"
                      [filterPlaceholder]="'admin.tool-history.lifecycle-history-table.filter.placeholder.partNumber' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="partNumber">
        <ng-template #body
                     let-toolLifecycleHistory="rowData">
            <span>{{ toolLifecycleHistory.partNumber.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.tool-history.lifecycle-history-table.columns.PC' | translate"
                      [filterPlaceholder]="'admin.tool-history.lifecycle-history-table.filter.placeholder.PC' | translate"
                      [headerTooltip]="'admin.tool-history.lifecycle-history-table.tooltips.PC' | translate"
                      field="TPCSPC">
        <ng-template #body
                     let-toolLifecycleHistory="rowData">
            <span>{{toolLifecycleHistory.totalProductionCycles}}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.tool-history.lifecycle-history-table.columns.PT' | translate"
                      [filterPlaceholder]="'admin.tool-history.lifecycle-history-table.filter.placeholder.PT' | translate"
                      [headerTooltip]="'admin.tool-history.lifecycle-history-table.tooltips.PT' | translate"
                      field="TPTSPT">
        <ng-template #body
                     let-toolLifecycleHistory="rowData">
            <span>{{toolLifecycleHistory.totalProductionTime}}</span>
        </ng-template>
    </app-table-column>
    <app-table-column #date
                      [header]="'admin.tool-history.lifecycle-history-table.columns.date' | translate"
                      [sortable]="true"
                      field="date">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  [placeholder]="'admin.tool-history.lifecycle-history-table.filter.placeholder.date' | translate"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>
    <app-table-column #ticket
                      [header]="'admin.tool-history.lifecycle-history-table.columns.ticket' | translate"
                      field=ticketId>
        <ng-template #body
                     let-toolLifecycleHistory="rowData">
                     <div (click)=openTicket(toolLifecycleHistory.ticketId) *ngIf="toolLifecycleHistory.ticketId" class="ticket">
                        <span>{{toolLifecycleHistory.ticketId}}</span>
                        <i class="material-icons">open_in_new</i>
                     </div>
        </ng-template>
    </app-table-column>
</app-table>
